import './styles.scss';
import casino from '../../assets/mr_logo_white.png';
import sport from '../../assets/mr_sport_logo.png';
import general from '../../assets/logo.png';

const lib = {
    sport,
    casino,
    general,
};

const Logo = ({ type = 'general' }) => {
	return (
		<div className='logo'>
			<img src={lib[type]} alt='magicred' />
		</div>
	);
};

export default Logo;
